// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// const firebaseConfig = {
//   apiKey: 'AIzaSyA2kY_BOCqqLBwbpjAG0-3DoHRYYIS77Qk',
//   authDomain: 'sifone-app-cc2a8.firebaseapp.com',
//   projectId: 'sifone-app-cc2a8',
//   storageBucket: 'sifone-app-cc2a8.appspot.com',
//   messagingSenderId: '479141844146',
//   appId: '1:479141844146:web:fe1a3fa35135883b0065ab',
//   measurementId: 'G-R8GZXZSMF0'
// };

const firebaseConfig = {
  apiKey: "AIzaSyD2iRDO5eR2x-mlguTeFuup7CvL0wRY-DM",
  authDomain: "coopsetec-31f72.firebaseapp.com",
  projectId: "coopsetec-31f72",
  storageBucket: "coopsetec-31f72.appspot.com",
  messagingSenderId: "976295142326",
  appId: "1:976295142326:web:10bcdc7fe2be5cceeb5717"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const authentication = getAuth(app);
